const hardcodes = {
  CND: "Condenser",
  VTB: "Out of Airstream Vestibule",
  HAR: "Harmonics Section",
  PLN: "Discharge Plenum",
  HUM: "Humidifier",
  FFT: "Final Filter",
  ATT: "Sound Attenuator",
  GHS: "Gas Heat",
  SAF: "Supply Fan",
  BDS: "Backdraft Damper",
  HWS: "Hot Water/Steam Primary",
  ELS: "Electric Heat",
  RHS: "Reheat",
  IAQ: "Indoor Air Quality Section",
  EVS: "DX Coil",
  EVF: "DX Coil/Filter Combo",
  CWS: "Chilled Water",
  PHS: "Pre-Heat Water/Steam",
  AFN: "Aerofin Pre-Heat Water/Steam",
  FLT: "Primary Filter",
  AMX: "Blender Section (Air Mix)",
  RAS: "Return",
  CTL: "Control Panel Section",
  BL1: "Blank Section 1",
  BL2: "Blank Section 2",
  BL3: "Blank Section 3",
  BL4: "Blank Section 4",
  BL5: "Blank Section 5",
  BL6: "Blank Section 6",
  SP1: "Shipping Split 1",
  SP2: "Shipping Split 2",
  XXX: "Special",
};

export const hardCodesList = () => Object.entries(hardcodes);
